import {useOktaAuth} from "@okta/okta-react";

function Logout() {
    const { oktaAuth, authState } = useOktaAuth();
    // Revoke tokens
    // These functions are written such that they always succeed, so there's no error to catch
    oktaAuth.revokeRefreshToken().finally(() =>
        oktaAuth.revokeAccessToken().finally(() =>
            oktaAuth.clearStorage()
        ));

    window.location = "/"
}

export default Logout;